export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10007.581dd1d2.jpg";